<script>
    import ModalBase from './ModalBase';
    import messages from './messages';


    export default {
        mixins: [
            ModalBase,
        ],

        data() {
            return {
                msg: messages,

                form: {
                    person: null,
                    org   : null,
                    mail : null,
                    tel   : null,
                },
            };
        },

        computed: {
            buttonText() {
                if (!this.formState.$submitted) {
                    return this.msg.buttonTextDefault;
                }
                if (this.formState.$invalid) {
                    return this.msg.buttonTextRequireAll;
                } else {
                    if (this.formSending) {
                        return this.msg.buttonTextSending;
                    } else {
                        if (this.formSent) {
                            return this.msg.buttonTextSent;
                        } else {
                            return this.msg.buttonTextDefault;
                        }
                    }

                }
            },
        },

        methods: {
            reset() {
                this.formState._reset();
                this.form          = {
                    person: null,
                    org   : null,
                    email : null,
                    tel   : null,
                };
            },
        },
    };
</script>

<template>
    <div class="modal" id="free-consult">
        <vue-form class="form"
            action="/ajax/consult"
            method="post"
            :state="formState"
            @submit.prevent="send"
        >
            <input type="hidden" value="Запрос консультации" data-alt="Тема" name="FormName"/>
            <!--<input type="hidden" value="" data-alt="" name="Desc"/>-->

            <h6 class="modal__heading">Получить бесплатную консультацию</h6>

            <validate class="form__group" :class="formGroupState(formState.Name)">
                <div class="form__label form__label_small">{{ msg.fields.name }}</div>
                <input class="form-input"
                    name="Name"
                    data-alt="ФИО"
                    v-model="form.person"
                    required
                    :disabled="formDisabled"
                    placeholder=""
                    type="text">
                <div class="form__error">{{ msg.fieldRequired }}</div>
            </validate>

            <validate class="form__group" :class="formGroupState(formState.OrgName)">
                <div class="form__label form__label_small">{{ msg.fields.org }}</div>
                <input class="form-input"
                    name="OrgName"
                    data-alt="Организация"
                    v-model="form.org"
                    required
                    :disabled="formDisabled"
                    placeholder=""
                    type="text">
                <div class="form__error">{{ msg.fieldRequired }}</div>
            </validate>

            <validate class="form__group" :class="formGroupState(formState.Email)">
                <div class="form__label form__label_small">{{ msg.fields.email }}</div>
                <input class="form-input"
                    name="Mail"
                    data-alt="Электронная почта"
                    v-model="form.mail"
                    required
                    :disabled="formDisabled"
                    placeholder=""
                    type="text">
                <div class="form__error">{{ msg.fieldRequired }}</div>
            </validate>

            <validate class="form__group" :class="formGroupState(formState.Phone)">
                <div class="form__label form__label_small">{{ msg.fields.telephone }}</div>
                <input class="form-input"
                    name="Phone"
                    data-alt="Телефон"
                    v-model="form.tel"
                    required
                    :disabled="formDisabled"
                    placeholder=""
                    type="text">
                <div class="form__error">{{ msg.fieldRequired }}</div>
            </validate>

            <div class="form__group" v-if="formErrorMessage">
                <div class="alert">
                    Произошла ошибка: «{{formErrorMessage}}»<br>
                    Попробуйте повторить отправку позже
                </div>
            </div>

            <div class="form__group text-right">
                <input class="btn btn_primary btn_large"
                    :class="submitClass"
                    :disabled="formDisabled"
                    :value="buttonText"
                    type="submit">
            </div>
        </vue-form>
    </div>
</template>
